export const formQuestions = [
  // BLOQUE 1 - CONTEXTO DEL NEGOCIO
  {
    id: "rol_negocio",
    block: 1,
    type: "single",
    question: "Rol dentro del negocio",
    microcopy: "El análisis está dirigido especialmente a CEOs y dueños de negocio.",
    options: [
      { value: "fundador", label: "Fundador / CEO" },
      { value: "socio", label: "Socio" },
      { value: "director_marketing", label: "Director de marketing" },
      { value: "director_operaciones", label: "Director de operaciones" },
      { value: "gerente", label: "Gerente o Manager" }
    ]
  },
  {
    id: "facturacion",
    block: 1,
    type: "single",
    question: "Facturación mensual aproximada",
    microcopy: "No buscamos exactitud, solo situar la etapa del negocio.",
    options: [
      { value: "<5k", label: "< 5.000 €" },
      { value: "5k-10k", label: "5.000 – 10.000 €" },
      { value: "10k-30k", label: "10.000 – 30.000 €" },
      { value: "30k-100k", label: "30.000 – 100.000 €" },
      { value: "100k+", label: "+100.000 €" }
    ]
  },

  // BLOQUE 2 - CLARIDAD Y CONTROL
  {
    id: "intro_bloque_2",
    block: 2,
    type: "intro",
    title: "Claridad, control y capacidad de escalar",
    description: "Aquí vemos cuánto control tienes sobre los números y qué pasaría si el negocio creciera de golpe.",
    microcopy: "No hay respuestas buenas o malas, solo información útil."
  },
  {
    id: "metricas_control",
    block: 2,
    type: "multiple",
    question: "¿Qué métricas tienes realmente bajo control?",
    microcopy: "",
    options: [
      { value: "ticket_medio", label: "Ticket medio" },
      { value: "cac", label: "CAC (Costo de Adquisición de Clientes)" },
      { value: "ltv", label: "LTV (Valor del Ciclo de Vida del Cliente)" },
      { value: "tasa_conversion", label: "Tasa de conversión" },
      { value: "margen_venta", label: "Margen por venta" },
      { value: "ninguna", label: "Ninguna con claridad" }
    ]
  },
  {
    id: "escalabilidad",
    block: 2,
    type: "single",
    question: "Si el mes que viene tuvieras un +50% de clientes, ¿podrías gestionarlos sin perder calidad ni control?",
    microcopy: "",
    options: [
      { value: "sin_problema", label: "Sí, sin problema" },
      { value: "con_estres", label: "Sí, pero con estrés" },
      { value: "colapsaria", label: "No, colapsaríamos" }
    ]
  },
  {
    id: "dependencia_operativa",
    block: 2,
    type: "single",
    question: "Si mañana desaparecieras por 2 semanas, ¿qué pasaría con el negocio?",
    microcopy: "",
    options: [
      { value: "normalidad", label: "Funcionaría con normalidad" },
      { value: "pequenos_problemas", label: "Habría pequeños problemas" },
      { value: "ralentizaria", label: "Se ralentizaría mucho" },
      { value: "detendria", label: "Prácticamente se detendría" }
    ]
  },

  // BLOQUE 3 - CRECIMIENTO Y TENSIÓN DEL SISTEMA
  {
    id: "intro_bloque_3",
    block: 3,
    type: "intro",
    title: "Crecimiento y tensión del sistema",
    description: "Ahora miramos cómo estás creciendo y dónde empiezan a aparecer los primeros síntomas de tensión.",
    microcopy: "Piensa en los últimos 3–6 meses."
  },
  {
    id: "fuentes_captacion",
    block: 3,
    type: "single",
    question: "¿Cuál es tu fuente principal de captación?",
    microcopy: "",
    options: [
      { value: "publicidad_redes", label: "Publicidad en redes (Google Ads, Meta Ads, etc)" },
      { value: "contenido_organico", label: "Contenido orgánico" },
      { value: "referidos", label: "Referidos" },
      { value: "captacion_directa", label: "Captación directa (mailing, llamadas, fuerza comercial, etc)" },
      { value: "no_clara", label: "No tengo una fuente clara" }
    ]
  },
  {
    id: "problema_captacion",
    block: 3,
    type: "single",
    question: "¿Cuál es tu mayor problema actual en captación?",
    microcopy: "",
    options: [
      { value: "baja_calidad", label: "Leads de baja calidad" },
      { value: "coste_elevado", label: "Coste elevado" },
      { value: "bajo_volumen", label: "Bajo volumen de leads" },
      { value: "baja_conversion", label: "Baja conversión a venta" }
    ]
  },
  {
    id: "punto_ruptura",
    block: 3,
    type: "single",
    question: "¿Qué parte del negocio sientes que está más cerca de romperse si sigues creciendo?",
    microcopy: "",
    options: [
      { value: "captacion", label: "Captación/Marketing" },
      { value: "ventas", label: "Ventas" },
      { value: "operaciones", label: "Operaciones" },
      { value: "atencion_cliente", label: "Atención al cliente" },
      { value: "mi_tiempo", label: "Mi tiempo / yo mismo" }
    ]
  },

  // BLOQUE 4 - OPERATIVA REAL
  {
    id: "intro_bloque_4",
    block: 4,
    type: "intro",
    title: "Operativa real del día a día",
    description: "Aquí vemos cómo se mueve el negocio por dentro: ventas, procesos y consumo de energía.",
    microcopy: "Responde pensando en cómo funciona una semana normal."
  },
  {
    id: "gestion_ventas",
    block: 4,
    type: "single",
    question: "¿Cómo gestionas ahora mismo el proceso de ventas?",
    microcopy: "",
    options: [
      { value: "depende_mi", label: "Depende casi totalmente de mí y no hay un proceso claro" },
      { value: "basico_no_documentado", label: "Hay un proceso básico, pero no está documentado ni medido" },
      { value: "crm_simple", label: "Proceso básico con CRM simple, pero poco optimizado" },
      { value: "crm_pipeline", label: "Proceso claro con CRM, pipeline y algunas automatizaciones" },
      { value: "optimizado", label: "Proceso predecible y optimizado de forma continua" }
    ]
  },
  {
    id: "procesos_complejos",
    block: 4,
    type: "multi_text",
    question: "¿Qué procesos sientes que son más complejos de lo que deberían?",
    microcopy: "Introduce hasta 3 procesos que consideres innecesariamente complejos.",
    maxInputs: 3,
    placeholders: [
      "Ej: Seguimiento de leads",
      "Ej: Facturación y cobros",
      "Ej: Onboarding de clientes"
    ]
  },
  {
    id: "mayor_coste",
    block: 4,
    type: "single",
    question: "¿Dónde sientes que se te va más tiempo o energía en el negocio?",
    microcopy: "",
    options: [
      { value: "resolver_problemas_fuegos", label: "Resolver problemas – Apagar fuegos" },
      { value: "tomar_decisiones", label: "Tomar decisiones" },
      { value: "coordinar", label: "Coordinar personas" },
      { value: "repetir_tareas", label: "Repetir tareas" }
    ]
  },

  // BLOQUE 5 - IA Y PRIORIDAD
  {
    id: "intro_bloque_5",
    block: 5,
    type: "intro",
    title: "IA, expectativas y prioridad",
    description: "No se trata de meter IA por moda, sino de ubicarla donde realmente libera capacidad y genera retorno.",
    microcopy: "Qué te gustaría que cambiara gracias a la IA."
  },
  {
    id: "expectativas_ia",
    block: 5,
    type: "multiple",
    question: "¿Qué esperas realmente de la IA en tu negocio?",
    microcopy: "",
    options: [
      { value: "ahorrar_tiempo", label: "Ahorrar tiempo" },
      { value: "sustituir_repetitivas", label: "Sustituir tareas repetitivas" },
      { value: "ayudar_decidir", label: "Ayudarme a decidir mejor" },
      { value: "escalar_ventas", label: "Escalar ventas" },
      { value: "no_claro", label: "No lo tengo claro" }
    ]
  },
  {
    id: "nivel_prioridad",
    block: 5,
    type: "single",
    question: "¿Qué nivel de prioridad tiene ahora mismo para ti?",
    microcopy: "",
    options: [
      { value: "alta", label: "Alta: necesito claridad ya" },
      { value: "media", label: "Media: quiero explorarlo" },
      { value: "baja", label: "Baja: solo estoy mirando" }
    ]
  },

  // BLOQUE 6 - PREGUNTA CLAVE
  {
    id: "intro_bloque_6",
    block: 6,
    type: "intro",
    title: "La pregunta clave del análisis",
    description: "Con esta respuesta, el sistema prioriza qué problemas son más urgentes al analizar tu negocio.",
    microcopy: "Piensa en aquello que, si se resolviera, desbloquearía muchas cosas."
  },
  {
    id: "problema_90_dias",
    block: 6,
    type: "textarea",
    question: "Si solo pudieras resolver UN problema de tu negocio en los próximos 90 días, ¿cuál sería?",
    microcopy: "",
    placeholder: "Ejemplo: dejar de apagar fuegos, tener un flujo estable de leads cualificados, que el equipo funcione sin depender de mí, etc."
  }
];
